// Liga um error boundary de rota à recuperação de bundle stale: se o erro que
// derrubou a tela é de chunk que não existe mais no edge, a página se recarrega
// sozinha na versão publicada em vez de exibir um stack trace.
//
// Retorna `true` enquanto a recarga está a caminho — o boundary pinta a tela de
// "atualizando" nesse intervalo. Retorna `false` quando as tentativas
// automáticas se esgotaram (a recarga não resolveu), e aí o boundary mostra a
// tela de erro com o botão manual.

import { useEffect, useState } from 'react';

import { canAutoRecover, isStaleBundleError, recoverFromStaleBundle } from './staleBundleRecovery';

export function useStaleBundleRecovery(error: unknown): boolean {
  const stale = isStaleBundleError(error);
  // Leitura pura no primeiro render: evita piscar a tela de erro antes de o
  // efeito disparar a recuperação.
  const [recovering, setRecovering] = useState(() => stale && canAutoRecover());

  useEffect(() => {
    if (!stale) return;
    setRecovering(recoverFromStaleBundle());
  }, [stale]);

  return recovering;
}
